
import React, { useMemo, useRef } from "react";
import './App.css'; // Reuse the same CSS for consistent styling  

//This adds proper “slider controls” and keeps scroll snap for the smooth feel.

function ReviewSnapSliderWithButtons() {
  const viewportRef = useRef(null);

  const reviews = useMemo(
    () => [
      { id: 1, text: "My daughter is in Year 8 and has been receiving maths tutoring with Dipali. Since starting lessons, her school test results have improved noticeably. She says the tutor explanations are very clear and easy to understand, which has helped her build a strong understanding of fundamentals. With a better grasp of basics, she has become more confident in applying her knowledge to solve more challenging problems. I am very pleased with her progress and highly recommend Dipali to other students looking to sterngthen their math skills.", name: "Year 8 Parent, Perth Modern School" },
      { id: 2, text: "My daughter has shown a significant improvement in maths after receiving tutoring at Sure Steps Learning. She says she now has a much better understanding of the subject, which has helped improve her maths grades. Thank you, Dipali, for your dedication and support.", name: "Year 8 Parent, Perth Modern School" },
      { id: 3, text: "Dipali is an excellent tutor! She explains concepts clearly and patiently, making even difficult topics easy to understand. Lessons are well-organised and adapted to my daughter's pace. She has gained much more confidence in maths and I've seen real improvements in her results. Highly recommend to anyone who wants to strengthen their maths skills and improve their grades", name: "Year 7 Parent, Carey Baptist College"  },
      { id: 4, text: "Sure Steps offered me a great tutoring experience. The tutor was understanding and guided me slowly through each topic. I overall felt much more confident in my mathematics skills and saw improvement in my tests.", name: "Year 7 Student, Perth Modern School" },
    ],
    []
  );

  const scrollBySlide = (dir) => {
    const el = viewportRef.current;
    if (!el) return;

    // find slide width based on viewport (since grid-auto-columns: 100%)
    const amount = el.clientWidth;
    el.scrollBy({ left: dir * amount, behavior: "smooth" });
  };

  return (
    <section className="snapSlider" aria-label="Customer reviews">
      <div className="snapHeader">
        <button className="snapBtn" type="button" onClick={() => scrollBySlide(-1)} aria-label="Previous review">
          ‹
        </button>

        <div ref={viewportRef} className="snapViewport" role="region" aria-roledescription="carousel">
          <div className="snapTrack">
            {reviews.map((r, idx) => (
              <article key={idx} className="snapSlide" aria-label={`Review ${idx + 1} of ${reviews.length}`}>
                <p className="snapText">“{r.text}”</p>
                <p className="snapName">— {r.name}</p>
              </article>
            ))}
          </div>
        </div>

        <button className="snapBtn" type="button" onClick={() => scrollBySlide(1)} aria-label="Next review">
          ›
        </button>
      </div>
    </section>
  );
}

export default ReviewSnapSliderWithButtons;